module.exports = __webpack_public_path__ + "static/media/red-box.82c6465e.png";